import type { Conversation, ConversationMessage } from '@/core/repositories/conversations'

type SupportState = Pick<Conversation, 'type' | 'category' | 'status' | 'closedAt'>

/** Admin outreach has no customer problem to resolve. Closure is internal. */
export function isSupportOutreach(c: Pick<Conversation, 'type' | 'category'>): boolean {
  return c.type === 'support' && ['announcement', 'alert', 'warning'].includes(c.category ?? '')
}

export function showsCustomerClosure(c: SupportState): boolean {
  return !isSupportOutreach(c) && (c.status === 'closed' || !!c.closedAt)
}

export function customerVisibleMessages(c: Pick<Conversation, 'type' | 'category'>, messages: ConversationMessage[]) {
  return isSupportOutreach(c)
    ? messages.filter(m => m.senderType !== 'system' || !['closed', 'reopened', 'rated'].includes(String(m.metadata?.systemEvent)))
    : messages
}
